export const C = {
  // ── Brand teal ───────────────────────────────────────────────────
  orange:    "#008C95",
  orangeD:   "#006E75",
  orangeL:   "#D0EFEF",   // light teal — hover fills, soft tints
  orangeXL:  "#F0FAFA",   // whisper teal — icon well backgrounds

  // ── Brand grays ──────────────────────────────────────────────────
  silver:    "#A7A8A9",   // secondary text, muted icons
  silverL:   "#C5C7C9",   // borders, dividers
  silverXL:  "#EBEEF0",   // page canvas, neutral badge fills

  // ── Page surfaces ────────────────────────────────────────────────
  bg:        "#F0F2F5",   // grey canvas — all page backgrounds
  bgCard:    "#FFFFFF",   // white — cards pop off the grey canvas
  bgHover:   "#D0EFEF",   // row/card hover tint

  // ── Text hierarchy ───────────────────────────────────────────────
  text:      "#1A1C1E",   // near-black primary
  textSub:   "#4B5563",   // secondary — readable
  textMuted: "#A7A8A9",   // tertiary = brand silver

  // ── Semantic — hover-only by design convention ───────────────────
  // These appear ONLY on hover states / interaction; never as static fills
  emerald:   "#059669",
  emeraldL:  "#ECFDF5",
  emeraldD:  "#047857",
  amber:     "#D97706",
  amberL:    "#FFFBEB",
  red:       "#DC2626",
  redL:      "#FEF2F2",
  blue:      "#2563EB",
  blueL:     "#EFF6FF",

  // ── Sidebar / Navigation (brand teal dark variants) ─────────────
  navy:      "#005F63",
  navyL:     "#007880",
  navyXL:    "#E0F5F6",

  // ── Compat aliases ───────────────────────────────────────────────
  white:     "#FFFFFF",
  slate:     "#EBEEF0",
  slateD:    "#C5C7C9",
  slateDD:   "#A7A8A9",
  bgHoverOld:"#F5F7F9",
  yellow:    "#FCDE3D",
  yellowL:   "#FEFBD0",
  yellowD:   "#D4B800",
};

export const G = {
  orange:   `linear-gradient(135deg, #006E75 0%, #008C95 100%)`,
  navy:     `linear-gradient(135deg, #006E75 0%, #008C95 100%)`,
  sidebar:  "#008C95",
  hero:     "#008C95",
  peach:    `linear-gradient(135deg, #D0EFEF 0%, #A8DEDE 100%)`,
};

// ── Elevation shadows ─────────────────────────────────────────────
export const shadow    = "0 1px 3px rgba(0,0,0,0.05), 0 1px 8px rgba(0,0,0,0.03)";
export const shadowMd  = "0 4px 16px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.03)";
export const shadowLg  = "0 8px 32px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)";
export const shadowXL  = "0 20px 56px rgba(0,0,0,0.10), 0 4px 16px rgba(0,0,0,0.05)";
export const shadowOrange = "0 4px 20px rgba(0,140,149,0.22)";

// ── Border radius ─────────────────────────────────────────────────
export const radius   = 12;
export const radiusSm = 8;
export const radiusLg = 16;
export const radiusXL = 24;

// ── Status badge helpers ──────────────────────────────────────────
// At rest: neutral brand colors. On hover: semantic color revealed.
export const STATUS_REST  = { bg: "#EBEEF0", color: "#4B5563" };
export const STATUS_HOVER = {
  // ── Green: done / received / compliant ───────────────────────────
  "Done":           { bg: "#ECFDF5", color: "#059669" },
  "Completed":      { bg: "#ECFDF5", color: "#059669" },
  "Active":         { bg: "#ECFDF5", color: "#059669" },
  "Signed":         { bg: "#ECFDF5", color: "#059669" },
  "Paid":           { bg: "#ECFDF5", color: "#059669" },
  "Received":       { bg: "#ECFDF5", color: "#059669" },
  "Uploaded":       { bg: "#ECFDF5", color: "#059669" },
  "Filed":          { bg: "#ECFDF5", color: "#059669" },
  "Submitted":      { bg: "#ECFDF5", color: "#059669" },
  "Finalised":      { bg: "#ECFDF5", color: "#059669" },
  "Up to Date":     { bg: "#ECFDF5", color: "#059669" },
  "Available":      { bg: "#ECFDF5", color: "#059669" },
  "In Business":    { bg: "#ECFDF5", color: "#059669" },
  "Registered":     { bg: "#ECFDF5", color: "#059669" },
  "Compliant":      { bg: "#ECFDF5", color: "#059669" },
  // ── Amber: in-progress / pending / due soon ──────────────────────
  "In Progress":    { bg: "#FFFBEB", color: "#D97706" },
  "Pending":        { bg: "#FFFBEB", color: "#D97706" },
  "Due This Week":  { bg: "#FFFBEB", color: "#D97706" },
  "Upcoming":       { bg: "#FFFBEB", color: "#D97706" },
  "Busy":           { bg: "#FFFBEB", color: "#D97706" },
  "In a Meeting":   { bg: "#FFFBEB", color: "#D97706" },
  "Due Soon":       { bg: "#FFFBEB", color: "#D97706" },
  "Not Started":    { bg: "#FFFBEB", color: "#D97706" },
  // ── Red: overdue / missing / non-compliant ───────────────────────
  "Overdue":        { bg: "#FEF2F2", color: "#DC2626" },
  "On Leave":       { bg: "#FEF2F2", color: "#DC2626" },
  "Not Received":   { bg: "#FEF2F2", color: "#DC2626" },
  "Missing":        { bg: "#FEF2F2", color: "#DC2626" },
  "Outstanding":    { bg: "#FEF2F2", color: "#DC2626" },
  "Not Filed":      { bg: "#FEF2F2", color: "#DC2626" },
  "Rejected":       { bg: "#FEF2F2", color: "#DC2626" },
  "Dissolved":      { bg: "#FEF2F2", color: "#DC2626" },
  "Non-Compliant":  { bg: "#FEF2F2", color: "#DC2626" },
  "Deregistered":   { bg: "#FEF2F2", color: "#DC2626" },
  // ── Teal: review / action needed ─────────────────────────────────
  "Review":         { bg: "#D0EFEF", color: "#008C95" },
  "On Lunch":       { bg: "#D0EFEF", color: "#008C95" },
  // ── Neutral: no action needed ─────────────────────────────────────
  "Draft":          { bg: "#EBEEF0", color: "#4B5563" },
  "Inactive":       { bg: "#EBEEF0", color: "#4B5563" },
  "Archived":       { bg: "#EBEEF0", color: "#4B5563" },
  "To Do":          { bg: "#EBEEF0", color: "#4B5563" },
  "Away":           { bg: "#EBEEF0", color: "#4B5563" },
  "N/A":            { bg: "#EBEEF0", color: "#4B5563" },
  "Not Registered": { bg: "#EBEEF0", color: "#4B5563" },
  "Not Due":        { bg: "#EBEEF0", color: "#4B5563" },
  "Open":           { bg: "#EBEEF0", color: "#4B5563" },
};

// ── Card-level hover styles keyed by semantic category ────────────
// Returns { border, shadow, bg } to apply on card mouseEnter.
// Returns null for statuses that don't warrant a color change.
export const CARD_HOVER = {
  green:  { border: "#059669", shadow: "0 0 0 2px #05966940, 0 4px 16px #05966920", bg: "#F0FDF4" },
  amber:  { border: "#D97706", shadow: "0 0 0 2px #D9770640, 0 4px 16px #D9770620", bg: "#FFFBEB" },
  red:    { border: "#DC2626", shadow: "0 0 0 2px #DC262640, 0 4px 16px #DC262620", bg: "#FEF2F2" },
  orange: { border: "#008C95", shadow: "0 0 0 2px #008C9540, 0 4px 16px #008C9520", bg: "#F0FAFA" },
};

// Maps a status string to a CARD_HOVER key (or null for neutral).
export function statusToCardHover(status) {
  const s = (status || "").toLowerCase().trim();
  if (["done","completed","active","signed","paid","received","uploaded","filed","submitted","finalised","up to date","available","in business","registered","compliant"].some(k => s.includes(k))) return "green";
  if (["overdue","missing","not received","outstanding","not filed","rejected","dissolved","non-compliant","deregistered","on leave"].some(k => s.includes(k))) return "red";
  if (["in progress","pending","due soon","upcoming","due this week","not started","busy"].some(k => s.includes(k))) return "amber";
  if (["review","action required","attention"].some(k => s.includes(k))) return "orange";
  return null;
}

// Maps a Dashboard severity string to a CARD_HOVER key.
export function severityToCardHover(severity) {
  if (severity === "red")    return "red";
  if (severity === "orange") return "orange";
  if (severity === "amber")  return "amber";
  return null;
}

// ── Client label colours ──────────────────────────────────────────
const _LABEL_PALETTE = [
  "#008C95","#A7A8A9","#C5C7C9","#4B5563","#008C95",
  "#A7A8A9","#C5C7C9","#4B5563","#008C95","#A7A8A9",
];
export function clientLabelColor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = ((h << 5) - h) + name.charCodeAt(i);
  return _LABEL_PALETTE[Math.abs(h) % _LABEL_PALETTE.length];
}
